import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import EmptyContent from "components/EmptyContent";
import {AssetsList} from "components/EntityList";
import {
  selectAssetsData,
  selectIncidentsOverviewLoading,
  selectTopNAssetsData
} from "store/selectors/incidentOverviewSelectors";
import CardSkeleton from "./CardSkeleton";

const AssetsCard = ({limit = 5}) => {
  const assets = useSelector(
    limit || limit === 0 ? selectTopNAssetsData(limit) : selectAssetsData
  );
  const loading = useSelector(selectIncidentsOverviewLoading);
  const hasData = assets.length > 0;
  const {t} = useTranslation();

  if (loading) {
    return <CardSkeleton />;
  }

  return hasData ? (
    <AssetsList data={assets} />
  ) : (
    <EmptyContent name={t("entity.label.assets").toLowerCase()} />
  );
};

AssetsCard.propTypes = {
  limit: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
};

export default AssetsCard;
